import { BreathingExercise, useListBreathingExercisesFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { BreathingExerciseCard } from "../BreathingExerciseCard/BreathingExerciseCard";
import { useTranslation } from "react-i18next";
import { ViewStateWrapper } from "UIPalette/ViewStateWrapper/ViewStateWrapper";
import { HorizontalScroll } from "shared/UI/HorizontalScroll/HorizontalScroll";

export type BreathingExerciseSelectorProps = {
  onStartExercise: (exercise: BreathingExercise, duration: number) => void;
};

export const BreathingExerciseSelector = ({ onStartExercise }: BreathingExerciseSelectorProps) => {
  const { t } = useTranslation();
  const { data, isLoading, error, mutate } = useListBreathingExercisesFunctionRequest(
    {},
    { revalidateOnMountIfStale: false, showErrorIfStale: false }
  );

  return (
    <ViewStateWrapper
      loading={isLoading}
      error={!!error}
      errorMessage={t("resources.breathingExercisesError")}
      onRetry={mutate}
      isFullScreenView={true}
    >
      <HorizontalScroll className="flex h-[50vh] min-h-[500px]">
        {data?.map((exercise, index) => {
          return (
            <div key={index} className="p-2 pb-4 w-80 lg:w-full shrink-0 lg:shrink">
              <BreathingExerciseCard exercise={exercise} onStartExercise={onStartExercise} />
            </div>
          );
        })}
      </HorizontalScroll>
    </ViewStateWrapper>
  );
};
